// extracted by mini-css-extract-plugin
export default {"logo":"Navbar_logo__o8J8F","navbar":"Navbar_navbar__1sSuW","buttondiv":"Navbar_buttondiv__U2M1Q","button":"Navbar_button__7ygFv"};